// @import_dependencies
import { store } from 'app_storage/redux-storage'
// @end

// @import services
// @end

// @import utilities
import { Http, HttpCustomStructure } from 'app_utils/http'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @import types
import { IHttpResponse } from 'app_types/httpTypes'
import { IModularsHttpResponse, IModularHttpResponse } from 'app_types/admin/modular/modularTypes'
// @end

class ModularService {

  private token: string
  private storeObject: any
  private Http: any
  private screenNotification: ScreenNotificationsUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor () {
    this.Http = Http
    this.storeObject = store
    this.screenNotification = new ScreenNotificationsUtil()
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  async listExternal(params: any = {}) {
    this.refreshAuthToken()

    let responseData: IModularsHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/admin/modular/external/`,
      auth_token: this.token,
      params: {
        ...params,
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  async list(params: any = {}) {
    this.refreshAuthToken()

    let responseData: IModularsHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/admin/modular`,
      auth_token: this.token,
      params: {
        ...params,
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }


  insertOrUpdate = async (postData: any, action: string = 'create') => {
    this.refreshAuthToken()

    const formData = new FormData()

    Object.keys(postData).map((key: string) => {
      if (key === 'filterCategories') {
        formData.append(key, JSON.stringify(postData[key]))
      } else if (key === 'coverFile' && postData[key][0]) {
        formData.append(key, postData[key][0])
      } else if (postData[key]) {
        formData.append(key, postData[key])
      }
    })

    let responseData: IModularHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/modular/${action}`,
      headers: new Headers({
        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
        'Content-Type': 'multipart/form-data',
      }),
      auth_token: this.token,
      params: formData,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData.modular
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  getOne = async (id: string) => {
    this.refreshAuthToken()

    let responseData: IModularHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/admin/modular/${id}`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData.modular
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  remove = async (id: string) => {
    this.refreshAuthToken()

    let responseData: IHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'DELETE',
      url: `/api/admin/modular/delete/${id}`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return true
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

}

export default ModularService
